module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Simple Act of Forgery")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Sixteen years before her spring break in the bars at the Berlin Film Festival with Tabea Blumenschein, Pat made another kind of pilgrimage to another European country—and it produced another act of forgery. She was still the official resident of a house on Sugan Road in New Hope, Pennsylvania (see “"), _c('span', {
    attrs: {
      "href": "#/9780312303754_ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Les Girls: Part 8")]), _vm._v("”), still travelling restlessly between countries, and still a month or so away from having her lifeline permanently crossed by a meeting with Caroline Besterman in London. Now she was in Paris to pay homage to the writer—himself a connoisseur of forgery and counterfeit—whose books she’d been reading since she was seventeen years old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On 12 July 1962 Pat emerged from a lengthy ride on the Paris metro and entered a large gate set in a stone wall so long she couldn’t see the end of it. She kept her eyes on her size 9½  shoes as they walked her up and over the hilly streets, “cobbled with huge, irregular stones,” of France’s largest literary gathering ground: the Père Lachaise Cemetery in “the 20th Arrondissement of eastern Paris.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“These stones,” she imagined with the kind of satisfaction that only thoughts of death could bring her, “must make a grim, loud noise when metal wheels of carts, carrying bodies, go over them!”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00004_00000"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00004_00000",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t only Pat Highsmith who had to watch her feet on the cobblestones of Père Lachaise. Every writer who makes the pilgrimage there—and every writer does; Père Lachaise is the Dead Letter Office of Literary Aspirations—ends up with her eyes on the ground and “not,” as Pat carefully noted in her cahier, “on the names on the vaults and tombs.” Part of the secret pleasure in wandering the streets of this city of the dead is the perpendicularity of the visitor’s position in relation to that of the defunct writers she is visiting; and no one strolling the cemetery wants to stumble on a stone and fall upon a grave. Pat, who would kill quite a few of her characters with nasty fictional falls, understood very well how the smallest irregularity in a rock could make the difference between life and death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    },
    attrs: {
      "id": "pg04"
    }
  }, [_vm._v("Paris is hot and bright this July day, perfect weather for cemetery walking. Fleecy clouds are chasing each other across an enormous expanse of Cézanne-blue sky, but Pat, who has a goal in mind, is not much interested in the atmosphere. She is carrying her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bolsa,")]), _vm._v(" one of those large woven bags she brought back from her five months in Mexico in the early 1940s and never threw away. In it, she packs a three-by-five-inch spiral “travelling” notebook, along with something to drink and something to smoke. These are the props of her creative life and she is never without them: a notebook, a fountain pen, a lit cigarette, a bottle—and her tenebrous imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because the only thing Pat likes more than a good list is a good map, she is very much at home here. The moment she walked through the gate, she was handed—without charge; this was 1962—a map of the cemetery. And she needs it: Père Lachaise is the largest burial ground in Paris. It has its own “real roads,” its own prominently posted dead celebrity lists, and the map Pat is looking at shows the neat segments into which the cemetery’s 105-acre plot is partitioned. But as she walks past the graves of Bizet, Balzac, and Alfred de Musset (and bypasses entirely the graves of Chopin, Sarah Bernhardt, and Isadora Duncan), “the only name which interested” her on the map was “Oscar Wilde’s.” She finally “reached [his grave] after nearly a mile of walking among time-darkened rectangular vaults.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I came upon Oscar’s [monument]—a large nearly square rectangle of granite with a large Egyptian figure in headdress, flying horizontally. Only his name on the front in large letters. On the back is engraved his birth and death dates, his achievements at school, data of the Newdigate Poetry prize at the age of 24, and then those great and most fitting lines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To an outsider artist—an outsider "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("everything")]), _vm._v("—like Pat Highsmith, the lines inscribed on Oscar’s marble headstone (from his poem “The Ballad of Reading Gaol”) seem to be written for her alone. “And alien tears will fill for him pity’s long-broken urn…. his mourners will be outcast men.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My eyes fill with tears,” she writes, and then corrects herself in her notebook: “(filled).” She doesn’t want her future readers to think she is composing these words as she weeps at Oscar’s grave. Nor she does she want them to feel she is conjugating the tense of her experience to harmonize the chronology of her notebook—something she has done many times before and will do many times again. This moment is too important, too "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("authentic,")]), _vm._v(" to counterfeit. (But, still, she never takes her eyes off her audience.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    },
    attrs: {
      "id": "pg02"
    }
  }, [_vm._v("“Such tears,” she writes, meaning her own, “are brief and deep, like a stab wound,” and her mind flashes to her own fear of obscurity as she “remember[s] well the various accounts of [Oscar’s] lonely, pauper’s funeral to which nearly nobody came.” Pat needn’t have worried. Her memorial service in Switzerland will have a full house and a German television crew to record it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then—perhaps it’s an early appearance by the little fiend from Satan’s Inner Circle who visited her in the preceding chapter—something rather odd happens; something which cuts another key to the complicated lock guarding the Highsmith imagination. The hypervigilant Pat misses a detail, mistakes a date, fastens on a wrong impression, and then creates a counterfeit description from her string of errors. It’s the kind of mistake she will make more and more as her imagination, never really at home in Europe, is distanced by decades from the only place and time she ever knew well: New York City in the 1940s and 1950s. This is the modus operandi she will apply to Christopher Petit in May of 1978 when she misspells the young journalist’s last name and then—improvising madly—turns him into a felon and a forger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although her tears for Oscar’s fate are deeply felt, Pat has always cast a cold eye on life and death. And so, as she weeps, she can’t stop herself from criticizing Oscar’s funerary architecture. This is a most inappropriate monument, she thinks, for the tomb of a writer whose meditations on forgery and counterfeit, seductive portrayal of criminals, and long, unlovely martyrdom for homosexuality have moved her since she was a teenager. But Pat’s critique of Oscar’s grave rests squarely on the error she has just made; the result of a faulty application of the talent she is widely supposed to have mastered: close observation of detail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat’s mistake is to imagine that the sculpture surmounting Oscar’s grave, Jacob Epstein’s famous funerary monument of a winged Egyptian erected in the belle epoque, in 1909, is an art deco construction of the “mid-Twenties.” What’s more, she judges “the Egyptian motif not at all appropriate” for Oscar Wilde. Thus, as well as getting the sculpture’s style and epoch all wrong, she fails to understand the suitability of a pharaonic figure for the tomb of a writer whose delusions of grandeur were as outsized as those of Ozymandias; a writer who composed his own Egyptian-influenced poem called “The Sphinx” and who gave the sobriquet “Sphinx” to one of his dearest friends, Ada Leverson, grandmother of Francis Wyndham, the author and critic who will shortly give Pat’s work its first and most intelligent written introduction in England.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And—was it her famous reluctance to see or speak in public anything that had to do with sex?—Pat also managed to miss the winged Egyptian’s most salient feature: the mutilation of its marble genitalia. Jacob Epstein, the sculptor, had been criticized before for his “undue attention” to the sexual characteristics of his statues, and the prominent genitalia of this one had been hacked away by industrious lycée students in the half century since the monument was put in place. When Janet Flanner made her own pilgrimage to Père Lachaise in the early 1920s to place a single black iris on Oscar’s tomb, Epstein’s statue had already been emasculated."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00004_00001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00004_00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" Even today, almost five decades after Pat’s visit, the winged Egyptian is still without its principal part.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so Pat Highsmith—inspired observer of minute detail, serious fan of all things Wildean, compulsive collector of dates and times in her cahiers—mistook every single thing she saw at the tomb of Oscar Wilde: the style, the substance, the suitability, the context, even the epoch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But at the graveside, the wheel of Pat’s imagination was already spinning her errors of understanding into fictional gold. Because she didn’t like what she had just misidentified as the “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art Deco")]), _vm._v(" Egyptian motif” of Oscar’s art nouveau Egyptian monument, she began to search her mind for a suitable replacement, for the kind of tomb "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" might have created for the King of Counterfeit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And inspiration came to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oscar’s funerary monument, Pat decided, “should have been a Greek boy.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b59c3f82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312303754_ch04.vue
// module id = 81
// module chunks = 0